// extracted by mini-css-extract-plugin
module.exports = {"Video__root":"_3_qI","Video__wrapper":"qKE2","Video__iframe":"S8Cq"};